import Axios from "axios";
import {
    SET_SALES_TEAM_LIST,
    UNSET_SALES_TEAM_LIST,
} from "@/store/mutation-types";
import { saveUpdateSalesTeam, getSalesTeams } from "@/store/api";

const state = {
    getSalesTeams: [],
    editingSalesTeams: null,
};

const getters = {
    getSalesTeams(state) {
        return state.getSalesTeams;
    },
    getEditingSalesTeams(state) {
        return state.editingSalesTeams;
    }
};

const mutations = {
    [SET_SALES_TEAM_LIST](state, data) {
        state.getSalesTeams = data;
    },
    [UNSET_SALES_TEAM_LIST](state) {
        state.getSalesTeams = [];
    },
    setEditingSalesTeams(state, data) {
        state.editingSalesTeams = data;
    }
};

const actions = {
    saveUpdateSalesTeam({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateSalesTeam, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getSalesTeams({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getSalesTeams, { params: data })
                .then(function (response) {
                    commit("SET_SALES_TEAM_LIST", response.data.data);
                    resolve(response.data.data);
                })
                .catch(function (error) {
                    commit("UNSET_SALES_TEAM_LIST");
                    reject(error);
                })
                .then((always) => {});
        });
    },

    // FIXED: The main problem was here
    getSaleTeamById({ commit }, data) {
        const getSaleOrderByIdApi = `${getSalesTeams}/${data}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(getSaleOrderByIdApi)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    commit("UNSET_SALES_TEAM_LIST");
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
